import React from 'react';
import { map, isEmpty, size, head, get, last } from 'lodash';
import moment from 'moment';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callWidgetActivity as CallWidgetActivity } from 'ui/views/widgets/callWidgetActivity';
 *
 * // render
 * <CallWidgetActivity propName='propValue'/>
 */
export const callWidgetActivitySuccess = ( props ) => {

    const { widget, items } = props;

    // dashed line class name
    const dashbedLineClassName = classnames( 'ui-call-widget-activity__items-pane__dashed-line', {
        'ui-call-widget-activity__items-pane__dashed-line--hidden': 2 > size( items ), // hide it when `items` are less than 2
        [ `ui-call-widget-activity__items-pane__dashed-line--top-offset-${ size( get( head( props.items ), 'values' ) ) }` ]: ! isEmpty( get( head( props.items ), 'values' ) ), // large offset from `top` if `subtitle` of the `first` item is present
        [ `ui-call-widget-activity__items-pane__dashed-line--bottom-offset-${ size( get( last( props.items ), 'values' ) ) }` ]: ! isEmpty( get( last( props.items ), 'values' ) ), // large offset from `bottom` if `subtitle` of the `last` item is present
    } );

    return (
        <div className='ui-call-widget-activity'>
             <p className='ui-call-widget-activity__title'>
            { getLabel( widget.title ) }
        </p>
            <div className='ui-call-widget-activity__items-pane'>

            <div className='ui-call-widget-activity__items-pane__group'>
                
                {/* dashed line */}
                <div className={ dashbedLineClassName }></div>

                {/* items */}
                <div className='ui-call-widget-activity__items-pane__items'>
                    {
                        map( items, item => {

                            // dynamic item class name
                            const itemClassName = classnames( 'ui-call-widget-activity__items-pane__items__item', {
                                [ `ui-call-disposition-activity__items-pane__items__item--height-${ size( item.values ) }` ]: ! isEmpty( item.values ),
                            } );

                            return (
                                <div key={ item.id } className={ itemClassName }>
                                    {/* values */}
                                    {
                                        map( item.values, ( _value, _index ) => {
                                            return (
                                                <p key={ _index } className='ui-off-call-disposition-activity__items-pane__items__item__title'>{ _value }</p>
                                            );
                                        } )
                                    }

                                    {/* timestamp */}
                                    <p className='ui-call-widget-activity__items-pane__items__item__timestamp'>{ moment( item.timestamp ).format( 'MM-DD-YYYY hh:mm:ss A' ) }</p>
                                </div>
                            );
                        } )
                    }
                    </div>
                </div>
            </div>
        </div>
    );
};

// set display name
callWidgetActivitySuccess.displayName = 'callWidgetActivitySuccess';

// set default props
callWidgetActivitySuccess.defaultProps = {};

// prop types
callWidgetActivitySuccess.propTypes = {};

// preloader view
export const callWidgetActivityPreloader = () => {
    return (
        <div className='ui-call-widget-activity-preloader'>
            <div className='ui-call-widget-activity-preloader__title'/>
            {
                    map( [ 1, 2 ], item => {
                        return (
                            <div key={ item } className='ui-call-widget-activity-preloader__item'>
                                <div className='ui-call-widget-activity-preloader__item__title'/>
                                <div className='ui-call-widget-activity-preloader__item__subtitle'/>
                            </div>
                        );
                    } )
                }
        </div>
    );
};

// set display name
callWidgetActivityPreloader.displayName = 'callWidgetActivityPreloader';

// set default props
callWidgetActivityPreloader.defaultProps = {};

// prop types
callWidgetActivityPreloader.propTypes = {};

export const callWidgetActivity = withNetworkState( callWidgetActivityPreloader, callWidgetActivitySuccess );

